import React, { useEffect, useState, useContext } from "react";
import {
  Box, Input, Table, Thead, Tbody, Tr, Th, Td, Spinner, Heading, FormControl, FormLabel, Select, Stack, Text, useToast
} from "@chakra-ui/react";
import axios from "axios";
import AuthContext from '../../contexts/AuthContext';

const InstrumentsPage = () => {
  const [keys, setKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const [instruments, setInstruments] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const { getToken } = useContext(AuthContext);
  const token = getToken();

  const api = axios.create({
    baseURL: "/api/trading212",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  // Carica le chiavi API all'avvio
  useEffect(() => {
    api.get("/keys")
      .then(res => setKeys(res.data))
      .catch(() => toast({ status: "error", title: "Errore nel caricamento chiavi" }));
    // eslint-disable-next-line
  }, []);

  // Carica strumenti quando cambia la chiave selezionata
  useEffect(() => {
    if (!selectedKey) return;
    setLoading(true);
    api.get(`/instruments?key_id=${selectedKey}`)
      .then(res => {
        setInstruments(res.data);
        setFiltered(res.data);
      })
      .catch(() => toast({ status: "error", title: "Errore nel caricamento strumenti" }))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, [selectedKey]);

  // Filtra strumenti
  useEffect(() => {
    if (!search) {
      setFiltered(instruments);
    } else {
      const s = search.toLowerCase();
      setFiltered(
        instruments.filter(
          i =>
            (i.ticker && i.ticker.toLowerCase().includes(s)) ||
            (i.name && i.name.toLowerCase().includes(s))
        )
      );
    }
  }, [search, instruments]);

  return (
    <Box maxW="900px" mx="auto" p={6}>
      <Heading mb={6}>Strumenti disponibili Trading 212</Heading>

      {/* Selezione chiave */}
      <FormControl mb={6}>
        <FormLabel>Seleziona chiave API</FormLabel>
        <Select
          placeholder="Seleziona una chiave"
          value={selectedKey || ""}
          onChange={e => setSelectedKey(Number(e.target.value))}
        >
          {keys.map(k => (
            <option key={k.id} value={k.id}>{k.name}</option>
          ))}
        </Select>
      </FormControl>

      {/* Filtro */}
      <Stack direction={{ base: "column", md: "row" }} spacing={4} mb={4}>
        <FormControl>
          <FormLabel>Filtra per ticker o nome</FormLabel>
          <Input
            placeholder="Cerca..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </FormControl>
      </Stack>

      {/* Tabella strumenti */}
      {loading ? (
        <Spinner />
      ) : (
        <Box overflowX="auto">
          <Table variant="simple" size="sm">
            <Thead>
              <Tr>
                <Th>Ticker</Th>
                <Th>Nome</Th>
                <Th>Tipo</Th>
                <Th>Valuta</Th>
                <Th>ISIN</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filtered.length === 0 && (
                <Tr>
                  <Td colSpan={5}><Text>Nessuno strumento trovato.</Text></Td>
                </Tr>
              )}
              {filtered.map((i, idx) => (
                <Tr key={idx}>
                  <Td>{i.ticker}</Td>
                  <Td>{i.name}</Td>
                  <Td>{i.type}</Td>
                  <Td>{i.currencyCode}</Td>
                  <Td>{i.isin}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
};

export default InstrumentsPage;